import React, { useState } from 'react';
import PropTypes from 'prop-types';

import ResourceTableBody from '@presentational/ResourceTableBody';
import ResourceTableHeaders from '@presentational/ResourceTableHeaders';
import { ta } from 'utils';

import ItemLink from '@presentational/ItemLink';

const propTypes = {
  reportData: PropTypes.arrayOf(PropTypes.shape({
    records: PropTypes.array.isRequired, // sale items
    transfer: PropTypes.object.isRequired,
    total_amount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    total_amount_money: PropTypes.string.isRequired,
  })),

  transferURLBase: PropTypes.string.isRequired,
}

const defaultProps = {

}

const returnColumns = [
  { size: 2, header: "ID", accessor: "bright_pearl_order_id" },
  { size: 2, header: ta("sale_report_item.order_date"), accessor: (log) => I18n.l("time.formats.long", log.goods_note_date) },
  { size: 2, header: ta("products_transfer.variant_sku"), accessor: "sku" },
  { size: 2, header: ta("general.quantity"), accessor: "quantity" },
  { size: 2, header: "Costo", accessor: "unit_cost_money" },
  { size: 2, header: "Costo + IVA", accessor: "amount_money" },
];

const ReturnsByTransfer = (props) => {
  return (
    <div>
      <ResourceTableHeaders
        columnsInfo={returnColumns}
      />
      { props.reportData.map( ({records, transfer, total_amount_money}, index)  =>
        <div key={index}>
          <ResourceTableBody
            columnsInfo={returnColumns}
            items={ records }
            itemURL={null}
          />
          <div className="container-fluid pv15 bg-gray mb40">
            <div className="row">

              <div className="col-md-10">
                Nota de Crédito por aplicar a factura <strong>{transfer.invoice_number}</strong>, ingresada en Entrega APU  <strong><ItemLink url={ props.transferURLBase.replace("URL_ID", transfer.id) } content={transfer.name} /></strong>
              </div>
              <div className="col-md-2">
                { total_amount_money }
              </div>

            </div>
          </div>
        </div>
      )}
    </div>
  )
};

ReturnsByTransfer.propTypes = propTypes;
ReturnsByTransfer.defaultProps = defaultProps;

export default ReturnsByTransfer;